module.exports = __webpack_public_path__ + "img/Sprogreformation_lapp.45c740c3.jpg";